import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { approveDepositRequest } from '../depositRequestsEndpoints'
import { depositRequestKeys } from '../depositRequestsQueryKeys'
import type { ApproveDepositRequestInput } from '../../types/depositRequestsTypes'

export function useApproveDepositRequestMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (input: ApproveDepositRequestInput) => approveDepositRequest(input),
    onSuccess: (_, vars) => {
      qc.invalidateQueries({ queryKey: depositRequestKeys.lists() })
      qc.invalidateQueries({ queryKey: depositRequestKeys.statusCounts() })
      qc.invalidateQueries({ queryKey: depositRequestKeys.detail(vars.id) })
    },
  })
}
